import {FeatureLayerProperties, GRAPHIC_ATTRS, GRAPHIC_ATTR_IDS} from "../../models";
import {MapLayerColor, MapTool} from "../../enums";
import {OBJECTID} from "../map";
import {DibujoType} from "../../../../chacra-core/models";

export const ADJUNTOS_LAYER: FeatureLayerProperties = {
  name: 'adjunto',
  title: 'Adjunto',
  objectIdField: OBJECTID,
  geometryType: DibujoType.POINT,
  spatialReference: {wkid: 4326},
  outFields: ['adjuntoNombre', 'adjuntoURL', 'adjuntoComentario'],
  opacity: 0.8,
  fields: [
    {name: 'graphicAttr', alias: 'Graphic Attr Type', type: 'string'},
    {name: 'featureName', alias: 'Feature Name', type: 'string'},
    {
      name: 'adjuntoNombre',
      alias: 'Nombre',
      type: 'string'
    },
    {
      name: 'adjuntoURL',
      alias: 'Enlace',
      type: 'string'
    },
    {
      name: 'adjuntoComentario',
      alias: 'Comentario',
      type: 'string'
    }
  ],
  renderer: {
    type: 'simple',
    symbol: {
      type: 'simple-marker',
      style: 'circle',
      color: MapLayerColor.adjuntoFill,
      size: '10px',
      outline: {
        color: MapLayerColor.adjuntoOutline,
        width: 1
      }
    }
  },
  graphicAttr: GRAPHIC_ATTRS.ADJUNTO,
  attrId: GRAPHIC_ATTR_IDS.ADJUNTO,
  exportable: false,
  tools: [MapTool.point]
};
